type CommentingStatus = {
  status?: string;
} | null | undefined;

/** True while a dispatched Feedback run or inline commenting pass is still generating comments. */
export function isCommentingKeepingChatTurnOpen(activeCommenting: CommentingStatus): boolean {
  return activeCommenting?.status === "in_progress";
}
